import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../../context/AuthProvider';
import { getPromoterEvents } from '../../../services/PromoterService';

export default function MainMenu(props) {
    const [path, setPath] = useState("");
    const { loggedIn, user, setError } = useContext(AuthContext);
    const [events, setEvents] = useState([]);
    const { t } = useTranslation();

    useEffect(() => {
        setPath(window.location.href);
    }, []);

    useEffect(() => {
        if (loggedIn && user) {
            fetchEvents();
        }
    }, [loggedIn, user]);

    const fetchEvents = async () => {
        try {
            console.log("User role: ", user);
            const res = await getPromoterEvents(user.id);
            console.log("Events: ", res.data);
            if (res.data.length > 0)
                setEvents(res.data);

        } catch (err) {
            // setError(err.message);
            console.log("error fetching events: ", err.message)
        }
    }

    return (
        <nav className="main-nav">
            <ul className="menu sf-arrows">
                <li className={`megamenu-container`} id="menu-home">
                    <Link to={`${process.env.PUBLIC_URL}`} className="sf">
                        {t("MainMenu.home")}
                    </Link>
                </li>
                <li className={path.indexOf("events") > -1 ? 'active' : ''}>
                    <Link to={`${process.env.PUBLIC_URL}/events`} className="sf">
                        {t("MainMenu.events")}
                    </Link>
                </li>
                <li className={path.indexOf("pages/about") > -1 ? 'active' : ''}>
                    <Link to={`${process.env.PUBLIC_URL}/pages/about`} className="sf">
                        {t("MainMenu.about")}
                    </Link>
                </li>
                {
                    loggedIn &&
                    <li className={path.indexOf("/shop/dashboard") > -1 ? 'active' : ''}>
                        <Link className="sf" to={{ pathname: '/shop/dashboard', state: { goto: 2 } }}>{t("MainMenu.orders")}</Link>
                    </li>
                }
                {
                    loggedIn && events && events.length > 0 &&
                    <li className={path.indexOf("promoter") > -1 ? 'active' : ''}>
                        <Link className="sf" to="/promoter" style={{ whiteSpace: 'nowrap' }}>{t("MainMenu.mySales")}</Link>
                    </li>
                }
                <li>
                    <Link to={`${process.env.PUBLIC_URL}/pages/groovoo-club`} className="sf">
                        {t("MainMenu.club")}
                    </Link>
                </li>
            </ul>
        </nav>
    );
}
